var error = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof credit !== "undefined") return resolve();
	__webpack_require__.l("https://credit.rtspro.dev/remoteEntry.js", (event) => {
		if(typeof credit !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		error.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		error.name = 'ScriptExternalLoadError';
		error.type = errorType;
		error.request = realSrc;
		reject(error);
	}, "credit");
}).then(() => credit);